import { OverlayListenerOptions } from 'primeng/api';

import { APP_MEDIA_QUERIES } from '../services/viewport.service';

function isAppViewport(): boolean {
  return typeof window !== 'undefined' && APP_MEDIA_QUERIES.some((query) => window.matchMedia(query).matches);
}

export function appOverlayListener(_event: Event, options?: OverlayListenerOptions): boolean | undefined {
  if (options?.type === 'scroll' && isAppViewport()) return false;
  return options?.valid;
}
